import React, { useContext } from "react"
import { observer } from "mobx-react"
import { Button, Group, Text } from "@mantine/core"
import { IconArrowRight } from "@tabler/icons-react"
import { AppWorkspaceContext } from "../../stores/AppWorkspace"
import { LANDING_COPY } from "../../../docs/catalog"
import type { Processor } from "../../../processors/catalog"
import { processorPath } from "../../helpers/constants"

// One config/processors.json row as a card, on the homepage and on
// /processors: the name, the summary, the production claim, and the way in. A
// planned row has no page, so it is drawn as "Coming next" with no link.
export const ProcessorCard: React.FC<{ processor: Processor }> = observer(({ processor }) => {
  const workspace = useContext(AppWorkspaceContext)

  if (processor.planned) {
    return (
      <li className="or-framework-card or-platform-card is-planned">
        <div className="or-framework-card-link">
          <Text className="or-framework-card-title">{processor.label}</Text>
        </div>
        <span className="or-coming-next">{LANDING_COPY.processors.comingNext}</span>
      </li>
    )
  }

  const path = processorPath(processor.id)
  const open = (event: React.MouseEvent) => {
    event.preventDefault()
    workspace.goProcessors(processor.id)
  }

  return (
    <li className="or-framework-card or-platform-card">
      <a className="or-framework-card-link" href={path} onClick={open}>
        <Text className="or-framework-card-title">{processor.label}</Text>
        <Text className="or-framework-card-pitch">{processor.summary}</Text>
        {processor.production ? (
          <Text className="or-framework-card-requires">{processor.production}</Text>
        ) : null}
      </a>
      <Group className="or-framework-card-actions" gap="xs" wrap="wrap">
        <Button component="a" href={path} size="sm" rightSection={<IconArrowRight size={16} />} onClick={open}>
          Get agent directions
        </Button>
      </Group>
    </li>
  )
})
